import DefaultLayout from '@/layouts/default';
import i18n from '@/i18n/config';
import { Construction } from '@/components/lottie/construction';

export default function CdnManagerPage() {
  return (
    <DefaultLayout>
      <div className="p-6">
        <h1 className="text-2xl font-bold">{i18n.t('nav.cdnManager')}</h1>
        <p className="text-default-500 mt-2">Manage CDN configurations and caches</p>
        <div className="mt-6 space-y-3">
          <div className="flex h-96 items-center justify-center">
            <Construction />
          </div>
          <p className="text-default-500 text-center">This page is under construction and will be available soon.</p>
        </div>
      </div>
    </DefaultLayout>
  );
}
